import formList from "./formList.vue";
export default formList;
